export default __webpack_public_path__ + "static/media/pantry1-afterC-2048w.0a698285.webp";